import React, { useRef, useState, useCallback } from "react";
import { ChevronsLeftRight } from "lucide-react";

// Slider avant/après : glissez le curseur pour comparer.
export const BeforeAfter = ({ before, after, alt = "", testId }) => {
  const ref = useRef(null);
  const [pos, setPos] = useState(50);
  const dragging = useRef(false);

  const update = useCallback((clientX) => {
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const p = ((clientX - rect.left) / rect.width) * 100;
    setPos(Math.max(0, Math.min(100, p)));
  }, []);

  const onDown = (e) => {
    dragging.current = true;
    update(e.touches ? e.touches[0].clientX : e.clientX);
  };
  const onMove = (e) => {
    if (!dragging.current) return;
    update(e.touches ? e.touches[0].clientX : e.clientX);
  };
  const onUp = () => { dragging.current = false; };

  return (
    <div
      ref={ref}
      data-testid={testId}
      className="relative aspect-square w-full overflow-hidden rounded-2xl select-none cursor-ew-resize bg-[var(--oz-bg-2)]"
      onMouseDown={onDown}
      onMouseMove={onMove}
      onMouseUp={onUp}
      onMouseLeave={onUp}
      onTouchStart={onDown}
      onTouchMove={onMove}
      onTouchEnd={onUp}
    >
      {/* Après (base) */}
      <img src={after} alt={`${alt} après`} className="absolute inset-0 w-full h-full object-cover" draggable={false} />
      {/* Avant (clippé) */}
      <div className="absolute inset-0 w-full h-full" style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}>
        <img src={before} alt={`${alt} avant`} className="w-full h-full object-cover" draggable={false} />
      </div>

      {/* Étiquettes */}
      <span className="absolute top-3 left-3 bg-black/55 text-white text-[10px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-full">Avant</span>
      <span className="absolute top-3 right-3 bg-[var(--oz-gold)] text-white text-[10px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-full">Après</span>

      {/* Divider + poignée */}
      <div className="absolute top-0 bottom-0 w-0.5 bg-white shadow-[0_0_0_1px_rgba(0,0,0,0.1)]" style={{ left: `${pos}%` }}>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white shadow-lg flex items-center justify-center">
          <ChevronsLeftRight className="w-5 h-5 text-[var(--oz-dark)]" />
        </div>
      </div>
    </div>
  );
};

export default BeforeAfter;
